// 对应 sidebar-07 的 NavUser：头像 + 昵称 + 邮箱，下拉里是账号设置、主题、帮助与退出。
import { ChevronsUpDown, LifeBuoy, LogOut, Moon, Shield, Sun, UserRound } from "lucide-react";
import { useNavigate } from "react-router";
import { Avatar } from "@/components/ui/avatar";
import { useConfirm } from "@/components/ui/confirm";
import { MenuContent, MenuItem, MenuLabel, MenuRoot, MenuSep, MenuTrigger } from "@/components/ui/menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { useAuth, useMe } from "@/lib/auth/session";
import { setTheme, useTheme, type Theme } from "@/lib/theme";

export function NavUser({ admin }: { admin?: boolean }) {
  const me = useMe();
  const { logout } = useAuth();
  const { isMobile } = useSidebar();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const theme = useTheme();
  const u = me.user;
  const card = (
    <>
      <Avatar name={u.display_name} src={u.avatar_url} tone="ct" />
      <span className="grid flex-1 text-left leading-tight">
        <span className="truncate body-medium">
          {u.display_name}
          {admin ? <span className="caption text-primary"> 管理员</span> : null}
        </span>
        <span className="truncate caption muted">{u.email}</span>
      </span>
    </>
  );

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <MenuRoot>
          <MenuTrigger asChild>
            <SidebarMenuButton size="lg" aria-label="账号菜单" className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
              {card}
              <ChevronsUpDown className="ml-auto size-4 muted" />
            </SidebarMenuButton>
          </MenuTrigger>
          <MenuContent side={isMobile ? "bottom" : "right"} align="end" sideOffset={4} label="账号菜单" className="w-(--radix-dropdown-menu-trigger-width) min-w-56">
            <MenuLabel>
              <span className="flex items-center gap-2 py-1 text-left" style={{ color: "var(--popover-foreground)", letterSpacing: 0 }}>
                {card}
              </span>
            </MenuLabel>
            <MenuSep />
            <MenuItem icon={<UserRound className="ico" />} onSelect={() => navigate("/settings")}>
              个人资料
            </MenuItem>
            {u.role === "admin" && !admin ? (
              <MenuItem icon={<Shield className="ico" />} onSelect={() => navigate("/admin")}>
                管理后台
              </MenuItem>
            ) : null}
            <MenuSep />
            <MenuItem
              icon={theme === "dark" ? <Sun className="ico" /> : <Moon className="ico" />}
              onSelect={(e) => {
                e.preventDefault();
                const next: Theme = theme === "dark" ? "light" : "dark";
                setTheme(next);
              }}
            >
              {theme === "dark" ? "切换到浅色主题" : "切换到深色主题"}
            </MenuItem>
            <MenuItem icon={<LifeBuoy className="ico" />} onSelect={() => navigate("/help")}>
              帮助中心
            </MenuItem>
            <MenuSep />
            <MenuItem
              icon={<LogOut className="ico" />}
              onSelect={async () => {
                const ok = await confirm({ title: "退出登录？", description: "退出后需要重新登录才能继续使用。", confirmText: "退出登录" });
                if (!ok) return;
                await logout();
                navigate("/login", { replace: true });
              }}
            >
              退出登录
            </MenuItem>
          </MenuContent>
        </MenuRoot>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
